<template>
  <ul :class="['cross-sell', { 'cross-sell--cart': cartPage }]">
    <cross-sell-item
      v-for="checkbox in checkboxes"
      :key="checkbox.checkbox_id"
      :checkbox="checkbox"
      :order-number="orderNumber"
      :mode="mode"
      @updateCart="updateCart"
    />
  </ul>
</template>

<script>
import CrossSellItem from '~/components/cross-sell/cross-sell-item/CrossSellItem'
export default {
  name: 'CrossSell',
  components: {
    CrossSellItem,
  },
  props: {
    productSku: {
      type: String,
      default: '',
    },
    orderNumber: {
      type: [Number, String],
      default: '',
    },
    caseDevice: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'product',
    },
  },
  async fetch() {
    try {
      const storeInfo = this.$store.getters.storeInfo
      const params = {
        ...storeInfo,
        case_device: this.caseDevice,
      }

      params.optimized = true

      const endpoint = this.productPage
        ? `bundle/product/${this.productSku}`
        : 'bundle/cart'

      const { checkboxes } = await this.$axios.$get(endpoint, {
        params,
      })

      this.checkboxes = checkboxes
      this.$emit('showcheckboxes', this.checkboxesLength > 0)
    } catch (err) {
      this.$displayTopMessage(this.$t('action_error'), {
        type: 'error',
      })
    }
  },
  data() {
    return {
      checkboxes: [],
    }
  },
  computed: {
    cartPage() {
      return this.mode === 'cart'
    },
    productPage() {
      return this.mode === 'product'
    },
    checkboxesLength() {
      return this.checkboxes.length
    },
  },
  watch: {
    caseDevice(newVal) {
      this.$fetch()
    },
  },
  methods: {
    updateCart(event) {
      this.checkboxes.forEach((checkbox, index) => {
        if (event.id === checkbox.checkbox_id) this.checkboxes.splice(index, 1)
      })
      this.$emit('updateCart', event.cart)
    },
  },
  fetchOnServer: false,
}
</script>

<style lang="scss" scoped>
.cross-sell {
  padding: 0;
  margin: 0 0 -30px;

  &.cross-sell--cart {
    margin: 0 -15px;
  }
}

@media (min-width: $screen_tablet) {
  .cross-sell {
    padding: 0;
    margin: 0;

    &.cross-sell--cart {
      margin: 0;
    }
  }
}
</style>
